import React, {useState, useCallback} from 'react'
import {Button, Col, Icon, Input, message, Row} from "antd";
import './index.less'
import {_login} from '../../constants/api'
import {setToken} from "../../utils/cookie";

import {COMMON_ROUTER} from "../../constants";

export default (props) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [sending, setSending] = useState(false);
  const [response, setResponse] = useState(false);
  const [showWechatCode, setShowWechatCode] = useState(false);


  const handleInput = useCallback((type, e) => {
    switch (type) {
      case "username":
        setUsername(e.target.value);
        break;
      case "password":
        setPassword(e.target.value);
        break;
      default:
        break;
    }
  })

  const handleSubmit = useCallback(() => {
    // setShowWechatCode(true)
    // props.history.replace(COMMON_ROUTER + '/orders')
    // var storage = window.localStorage;
    // storage.setItem('SHOP_ID', 1);
    _login({
      nickName: username,
      pass: password
    }).then((res) => {
      console.log(res)
      //存储token
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (!window.localStorage) {
            alert('浏览器不支持localstorage');
            return false;
          } else {
            var storage = window.localStorage;
            storage.setItem('USER_NAME', data.data.nickName);
            storage.setItem('USER_PHONE', data.data.mobile);
            storage.setItem('SHOP_ID', data.data.userId);
            storage.setItem('OPEN_ID', data.data.openId);
            storage.setItem('ROLE_TYPE', data.data.roleType);
            storage.setItem('TEAM_ID', data.data.teamId);
          }
          setToken(data.data.openId)
          props.history.replace(COMMON_ROUTER + '/order')
        } else {
          message.error(data.msg)
        }
      }

    }).catch(error => {
      message.error(error)
    })
  })

  const onKeyDownchange = (e)=> {
    if (e.keyCode == 13) {
      handleSubmit()
    }
  }

  return (
    <div className="form-container">
      <Row>
        <Col style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%', marginLeft: '16%', marginRight: '16%'}}>
          <div className="form-wrapper">
            <h1 className="text-center">寻梦优选商户管理</h1>
            <Input
              prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
              placeholder="请输入用户名"
              value={username}
              onKeyDown={
                e => onKeyDownchange(e)
              }
              onChange={(e) => handleInput('username', e)}
            />

            <Input.Password
              prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
              placeholder="请输入密码"
              value={password}
              onKeyDown={
                e => onKeyDownchange(e)
              }
              onChange={(e) => handleInput('password', e)}
            />

            {
              // showWechatCode ? null :
                  <Row gutter={16}>
                    <Col span={24} className="p-5">
                      <Button block type="primary" onClick={handleSubmit} onKeyDown={e=> onKeyDownchange(e)}> 登录 </Button>
                    </Col>
                  </Row>
            }
            {
              // showWechatCode ?
              //     <Row gutter={16}>
              //       <Col span={24} className="p-5">
              //         <img style={{width: 200, height: 200}} src={IMAGE_PATH + "/assets/favicon-logo.png"} alt="" />
              //       </Col>
              //     </Row>
              //     :
              //     null
            }
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={8} offset={8}>
          <h2 className="text-center">
            {
              (response) &&
              JSON.stringify(response)
            }
          </h2>
        </Col>
      </Row>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/login/index.js